// Task 11 — Frontend SSN input + validation helpers.
//
// Validation matches services/ssn.py::validate_ssn so the FE rejects
// invalid SSNs before submit (server still re-validates).

export const SSN_MASK_CHAR = "\u2022";

export function ssnToDigits(value) {
    return String(value || "").replace(/\D/g, "");
}

export function formatSsn(digits) {
    // Allow partial format as the user types.
    const d = ssnToDigits(digits);
    if (d.length <= 3) return d;
    if (d.length <= 5) return `${d.slice(0, 3)}-${d.slice(3)}`;
    return `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5, 9)}`;
}

export function maskSsn(digits) {
    const d = ssnToDigits(digits);
    if (d.length !== 9) return d;
    return `${SSN_MASK_CHAR.repeat(3)}-${SSN_MASK_CHAR.repeat(2)}-${d.slice(5)}`;
}

export function isMaskedSsn(value) {
    return !!value && String(value).includes(SSN_MASK_CHAR);
}

export function validateSsn(value) {
    const d = ssnToDigits(value);
    if (d.length !== 9) return "SSN must be exactly 9 digits";
    if (d === "000000000") return "SSN must not be all zeros";
    const area = d.slice(0, 3);
    const group = d.slice(3, 5);
    const serial = d.slice(5);
    if (area === "000" || area === "666" || area[0] === "9") {
        return "SSN area number is invalid";
    }
    if (group === "00") return "SSN group number is invalid";
    if (serial === "0000") return "SSN serial number is invalid";
    return null;
}
